// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__20srx","head":"ProcedureTableInfo_head__1Izsw"};